/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  Manuals,
  ErrorInfo,
  PostManualsBody,
  BinaryFile,
  PostManualsAddBody,
  PostManualsUpdateBody
} from '.././model'


/**
 * マニュアル画面の一覧を取得

 * @summary マニュアル検索
 */
export const postManuals = (
    postManualsBody: PostManualsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Manuals>> => {
    return axios.post(
      `/manuals`,
      postManualsBody,options
    );
  }



    export type PostManualsMutationResult = NonNullable<Awaited<ReturnType<typeof postManuals>>>
    export type PostManualsMutationBody = PostManualsBody
    export type PostManualsMutationError = AxiosError<ErrorInfo>

    export const usePostManuals = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManuals>>, TError,{data: PostManualsBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManuals>>, {data: PostManualsBody}> = (props) => {
          const {data} = props ?? {};

          return  postManuals(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManuals>>, TError, {data: PostManualsBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マニュアル一括ダウンロード（zip）

 * @summary マニュアル一括ダウンロード
 */
export const postManualsDownloadall = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/manuals/downloadall`,undefined,options
    );
  }



    export type PostManualsDownloadallMutationResult = NonNullable<Awaited<ReturnType<typeof postManualsDownloadall>>>
    
    export type PostManualsDownloadallMutationError = AxiosError<ErrorInfo>

    export const usePostManualsDownloadall = <TError = AxiosError<ErrorInfo>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualsDownloadall>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualsDownloadall>>, TVariables> = () => {
          

          return  postManualsDownloadall(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualsDownloadall>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マニュアルダウンロード

 * @summary マニュアルダウンロード
 */
export const postManualsDownload = (
    manualId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/manuals/${manualId}/download`,undefined,options
    );
  }



    export type PostManualsDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postManualsDownload>>>
    
    export type PostManualsDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostManualsDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualsDownload>>, TError,{manualId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualsDownload>>, {manualId: number}> = (props) => {
          const {manualId} = props ?? {};

          return  postManualsDownload(manualId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualsDownload>>, TError, {manualId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マニュアルファイル追加

 * @summary マニュアルファイル追加
 */
export const postManualsAdd = (
    postManualsAddBody: PostManualsAddBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postManualsAddBody.comment !== undefined) {
 formData.append('comment', postManualsAddBody.comment)
 }
if(postManualsAddBody.file !== undefined) {
 formData.append('file', postManualsAddBody.file)
 }

    return axios.post(
      `/manuals/add`,
      formData,options
    );
  }



    export type PostManualsAddMutationResult = NonNullable<Awaited<ReturnType<typeof postManualsAdd>>>
    export type PostManualsAddMutationBody = PostManualsAddBody
    export type PostManualsAddMutationError = AxiosError<ErrorInfo>

    export const usePostManualsAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualsAdd>>, TError,{data: PostManualsAddBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualsAdd>>, {data: PostManualsAddBody}> = (props) => {
          const {data} = props ?? {};

          return  postManualsAdd(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualsAdd>>, TError, {data: PostManualsAddBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マニュアルコメント更新

 * @summary マニュアルコメント更新
 */
export const postManualsUpdate = (
    postManualsUpdateBody: PostManualsUpdateBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {const formData = new FormData();
if(postManualsUpdateBody.manual_id !== undefined) {
 formData.append('manual_id', postManualsUpdateBody.manual_id.toString())
 }
if(postManualsUpdateBody.comment !== undefined) {
 formData.append('comment', postManualsUpdateBody.comment)
 }

    return axios.post(
      `/manuals/update`,
      formData,options
    );
  }



    export type PostManualsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postManualsUpdate>>>
    export type PostManualsUpdateMutationBody = PostManualsUpdateBody
    export type PostManualsUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostManualsUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualsUpdate>>, TError,{data: PostManualsUpdateBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualsUpdate>>, {data: PostManualsUpdateBody}> = (props) => {
          const {data} = props ?? {};

          return  postManualsUpdate(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualsUpdate>>, TError, {data: PostManualsUpdateBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * マニュアルファイル削除

 * @summary マニュアルファイル削除
 */
export const postManualsDelete = (
    manualId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/manuals/delete/${manualId}`,undefined,options
    );
  }



    export type PostManualsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postManualsDelete>>>
    
    export type PostManualsDeleteMutationError = AxiosError<ErrorInfo>

    export const usePostManualsDelete = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postManualsDelete>>, TError,{manualId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postManualsDelete>>, {manualId: number}> = (props) => {
          const {manualId} = props ?? {};

          return  postManualsDelete(manualId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postManualsDelete>>, TError, {manualId: number}, TContext>(mutationFn, mutationOptions)
    }
    